import React, {useEffect, useImperativeHandle, useRef, useState} from 'react'
import WizModal from '../../../components/modal/WizModal'
import Text from '../../../components/text/Text'
import WizButton from '../../../components/button/WizButton'
import UnderLineInput from '../../../components/input/UnderLineInput'
import {postEditUser} from '../../../apis/user/editUser'

interface IProps {
    className?: string
    nickname: string
    userId: string
    refetch?: any
}

const ChangedNicknameModal = ({className, nickname, userId, refetch}: IProps, ref: any) => {
    const modalRef = useRef<any>()
    const [userNickname, setUserNickname] = useState('')

    useImperativeHandle(ref, () => ({
        show: () => {
            modalRef.current.show()
        },
    }))

    useEffect(() => {
        setUserNickname(nickname)
    }, [nickname])

    const onClickSubmit = async () => {
        await postEditUser({id: userId, name: userNickname})
        refetch()
        modalRef.current.close()
    }

    return (
        <>
            <WizModal title={'Changed Nickname'} className={`${className}`} ref={modalRef}>
                <Text className={'text-body2 text-font02'}>변경하려하는 닉네임을 작성해주세요. </Text>
                <UnderLineInput value={userNickname} className={'mt-[10px]'} onChanged={setUserNickname} />
                <div className={'flex space-x-[5px] mt-[30px]'}>
                    <WizButton
                        text={'Cancel'}
                        type={'cancel'}
                        className={'flex-1'}
                        onClick={() => {
                            modalRef.current.close()
                        }}
                    />
                    <WizButton text={'Submit'} type={'blue'} className={'flex-1'} onClick={() => onClickSubmit()} />
                </div>
            </WizModal>
        </>
    )
}

export default React.forwardRef(ChangedNicknameModal)
